import styled from 'styled-components';

export const CarouselImageSectionRoot = styled.div<{
  backgroundColor?: string;
}>`
  background-color: ${({ backgroundColor }) => backgroundColor || '#f3fcfe'};
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 6.2rem 1rem 2.2rem 1rem;

  .react-multi-carousel-track {
  }

  .react-multi-carousel-item {
    transition: all 0.3s ease-in-out;
    transform: rotateX(35deg);
  }

  .react-multi-carousel-dot-list {
    position: relative;
    margin-top: 2rem;
  }

  .react-multi-carousel-dot button {
    border-color: ${({ theme }) => theme.color.mobilityBlue};
    border-width: 1.9px;
  }

  .react-multi-carousel-dot--active button {
    background-color: ${({ theme }) => theme.color.mobilityBlue};
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    .middle-active {
      opacity: 1 !important;
      margin-top: -31px;
      height: 370px;
    }
  }

  @media (min-width: 1600px) and (max-width: 1766px) {
    .middle-active {
      height: 410px;
    }
  }

  @media (min-width: 1080px) and (max-width: 1140px) {
    .middle-active {
      height: 430px;
    }
  }

  @media (min-width: 1140px) and (max-width: 1440px) {
    .middle-active {
      opacity: 1 !important;
      margin-top: -30px;
      height: 400px;
    }
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 0 0 2.2rem 0;
  }
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 1504px;

  margin-bottom: 3rem;
  padding: 2rem 0rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: 90%;
    margin-bottom: 1rem;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    width: 90%;
    margin-bottom: 0rem;
  }
`;

export const DescriptionText = styled.div<{ color?: string }>`
  color: ${({ color, theme }) => color || theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: ${({ theme }) => theme.fontWeight.weight800};
  line-height: ${({ theme }) => theme.lineHeight.height140};

  margin-bottom: 2rem;
  text-align: center;
  width: 100%;
  position: relative;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
    margin-bottom: 4rem;
  }
`;

export const Image = styled.img`
  width: 166px;
  height: 80px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  background-color: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  margin-left: 2rem;
  margin-right: 2rem;
  padding: 4rem 4rem 2rem 4rem;
  text-align: center;

  opacity: 0.6;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    opacity: 1;
    padding: 3.5rem 2rem 4rem 2rem;
    margin-left: 0;
    margin-right: 0;
    justify-content: space-between;
  }
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size40};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height115};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size32};
    padding: 4rem 2rem 0rem 2rem;
    margin-bottom: 0rem;
  }
`;
